<template>
  <footer v-if="isVotingOpen" class="bg-light py-4">
    <div class="container d-flex justify-content-center">
      <CButton color="danger" shape="pill" size="lg" class="mx-3">
        Vote
      </CButton>
      <CButton color="dark" shape="pill" size="lg">
        Abstention
      </CButton>
    </div>
  </footer>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
  name: 'vote',
  props: {
    isVotingOpen: {
      type: Boolean,
      required: true
    },
    icon: {
      type: String,
      default: 'cil-bell'
    },
    caption: {
      type: String,
      default: 'ศูนย์แจ้งเหตุฉุกเฉิน'
    },


  },
  data() {
    return {

    }
  },

  mounted() {

  },

  created() {
    this.onInit();
  },

  beforeDestroy() {

  },

  methods: {
    onInit() {

    },
  },

  computed: {
    ...mapGetters({
    })
  },

  watch: {



  }
}

</script>
